import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'portIconPipe'})
export class PortIconPipe implements PipeTransform {
  transform(type: number): string {
    switch(type) {
      case 1: {
        return 'digitalInputIcon';
      }
      case 2: {        
        return 'digitalOutputIcon';
      }
      case 3: {
        return 'analogInputIcon';
      }
      case 4: {
        return 'analogOutputIcon';
      }
      default: {
        return 'cancel_presentation';
      }
    }
  }
}